import { render, staticRenderFns } from "./OrderServiceGeneralQuotation.vue?vue&type=template&id=1ad8487e&"
import script from "./OrderServiceGeneralQuotation.vue?vue&type=script&lang=js&"
export * from "./OrderServiceGeneralQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports